import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

import Delo from "../../img/organizers/delo.svg";
import Mmr from "../../img/organizers/mmr.svg";
import Top from "../../img/organizers/top100.svg";
import Womo from "../../img/organizers/womo.svg";
import Ekonomika from "../../img/organizers/Logo_Ekonomika.svg";

import Get from "../../img/organizers/get.svg";
import Hrws from "../../img/organizers/hrws.svg";
import Prmrfn from "../../img/organizers/prmrfn.svg";
import She from "../../img/organizers/she.svg";
import Bws from "../../img/organizers/bws.svg";
import Mrktng from "../../img/organizers/mrktng.svg";

import OrgDecor from "../../img/decor/org_decor.svg";
import OrgDecorCenter from "../../img/decor/org_decor_center.svg";



const EventOrganizers = () => {
    return (
        <section className="relative bg-[#fff] py-[60px] lg:py-[120px]">
            <div className="container max-w-screen-xl mx-auto px-5">
                <div className="relative mb-8 lg:mb-20">
                    <h2 className="uppercase text-center text-3xl sm:text-4xl lg:text-[52px] mb-14 lg:mb-[100px]">Організатори</h2>

                    <div className="relative z-10 flex justify-center gap-4 md:justify-between">
                        {/* DELO */}
                        <a href="https://delo.ua" target="_blank" rel="noopener noreferrer"
                            className="relative flex flex-1 items-center justify-center text-right bg-[#F4F0EA] rounded-[3px] px-[15px] w-full 
                                max-w-[127px] lg:max-w-[246px] lg:min-h-[106px] lg:justify-start">
                            <p className="text-[9px] leading-[130%] z-10 max-w-full md:text-[11px] lg:text-[16px] lg:max-w-[150px]">
                                лідер ділового контенту Delo.ua
                            </p>
                            <span className="absolute z-10 w-[73px] h-[73px] bg-[#F4F0EA] rounded-full flex items-center justify-center 
                                top-[30px] -left-[40px] md:-top-[10px] md:left-auto md:-right-[55px] lg:w-[120px] lg:h-[120px]">
                                <img src={Delo} alt="delo" className="w-[60%] relative z-10" />
                                <img src={OrgDecor} className="absolute h-full w-full object-cover -right-[2px] lg:-right-[6px]  top-[2px]"/>
                            </span>

                            <span className="absolute w-[60px] h-[18px] -bottom-[63px] left-0 md:w-[110px] md:h-[23px] md:left-[125%] md:bottom-[15px] 
                                lg:w-[175px] lg:h-[53px] lg:left-[120%]">
                                <svg viewBox="0 0 155 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M153 34.5L120 1.5H0" stroke="#E8B500" stroke-width="3" stroke-dasharray="10 10" />
                                </svg>
                            </span>

                        </a>

                        {/* MMR */}
                        <a href="https://mmr.ua" target="_blank" rel="noopener noreferrer"
                            className="relative flex flex-1 items-center justify-center text-left bg-[#F4F0EA]  rounded-[3px] px-[15px] w-full max-w-[127px] min-h-[58px] lg:max-w-[246px] lg:min-h-[106px] lg:justify-end">
                            <p className="text-[9px] leading-[130%] z-10 max-w-full md:text-[11px] lg:text-[16px] lg:max-w-[150px]">
                                онлайн-медіа про PR та маркетинг MMR.ua
                            </p>
                            <span
                                className="absolute z-10 w-[73px] h-[73px] bg-[#F4F0EA] rounded-full flex items-center justify-center top-[34px] -right-[40px] md:-top-[10px] md:right-auto md:-left-[55px] lg:w-[120px] lg:h-[120px]">
                                <img src={Mmr} alt="mmr" className="w-[60%] relative z-10" />
                                <img src={OrgDecor} className="absolute h-full w-full object-cover -right-[2px]   top-[3px]"/>
                            </span>
                           <span
                                className="absolute w-[60px] h-[18px] -bottom-[64px] right-0 md:w-[110px] md:h-[23px] md:right-[125%] md:bottom-[15px] 
                                    lg:w-[175px] lg:h-[53px] lg:right-[110%]">
                                <svg viewBox="0 0 154 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 34L34 1H154" stroke="#E8B500" strokeWidth="2" strokeDasharray="10 10" />
                                </svg>
                            </span>
                        </a>
                    </div>
                    {/* CENTER BLOCK */}
                    <div className="relative flex justify-center py-[25px] md:py-0 md:my-[-50px] ">
                        <a href="https://ekonomika.ua/" target="_blank" rel="noopener noreferrer"
                            className="relative flex shrink-0 flex-col items-center justify-center gap-[10px] md:gap-[20px] w-[162px] h-[162px] 
                            md:w-[210px] md:h-[210px] lg:w-[340px] lg:h-[340px] rounded-full  text-center">
                            <img src={Ekonomika} alt="Ekonomika+" className="w-[120px] md:w-auto z-10 relative" />
                            <p className="text-[10px] md:text-[20px] leading-[130%] text-balance z-10 relative">бізнес/медіа бюро, до
                                якого входять:</p>
                            {[['top-[25px]', '-left-[3px]', 'left-0'], ['top-[25px]', '-right-[3px]', 'right-0'], ['bottom-[25px]', '-left-[3px]', 'left-0'], ['bottom-[25px]', '-right-[3px]', 'right-0']].map(([pos, shift, reset], i) => (
                                <span key={i}
                                    className={`absolute z-10 w-[18px] h-[18px] lg:w-[40px] lg:h-[40px] bg-[#E8B500] border-[2.5px] md:border-[5px] border-white rounded-full ${pos} ${shift} md:${reset}`} />
                            ))}
                            <span
                                className="absolute bg-[#DDDFDD] w-[175px] h-[175px] md:w-[240px] md:h-[240px] lg:w-[390px] lg:h-[390px] rounded-full border-[6px] border-[#E8B500]" />
                            <img src={OrgDecorCenter} className="absolute h-[110%] w-[110%] object-cover "/>
                        </a>
                    </div>
                    
                    {/* BOTTOM */}
                    <div className="relative z-10 flex justify-center gap-4 md:justify-between">
                        {/* TOP 100 */}
                        <a href="https://delo.ua/top100" target="_blank" rel="noopener noreferrer"
                            className="relative flex flex-1 items-center justify-center bg-[#F4F0EA] rounded-[3px] px-[15px] w-full max-w-[127px] min-h-[58px] lg:justify-start lg:max-w-[246px] lg:min-h-[106px]">
                            <p className="text-[9px] leading-[130%] z-10 max-w-full md:text-[11px] md:text-right lg:text-[16px] lg:max-w-[150px]">
                                журнал «ТОП-100. Рейтинги найбільших»
                            </p>
                            <span
                                className="absolute z-10 w-[73px] h-[73px] bg-[#F4F0EA] rounded-full flex items-center justify-center bottom-[35px] -left-[40px] md:-bottom-[7px] md:left-auto md:-right-[55px] lg:w-[120px] lg:h-[120px]">
                                <img src={Top} alt="top100" className="w-[60%] relative z-10" />
                                <img src={OrgDecor} className="absolute h-full w-full object-cover -right-[2px] lg:-right-[6px]  top-[2px]"/>
                            </span>
                            <span
                                className="absolute w-[60px] h-[18px] -top-[60px] left-0 md:w-[110px] md:h-[23px] md:left-[125%] md:top-[15px] 
                                    lg:w-[175px] lg:h-[53px] lg:left-[110%] lg:top-[25px]">
                                <svg viewBox="0 0 154 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M153 1L120 34H0" stroke="#E8B500" strokeWidth="2" strokeDasharray="10 10" />
                                </svg>
                            </span>
                        </a>

                        {/* WOMO */}
                        <a href="https://womo.ua" target="_blank" rel="noopener noreferrer"
                            className="relative flex flex-1 items-center justify-center bg-[#F4F0EA] rounded-[3px] px-[15px] w-full max-w-[127px] min-h-[58px] lg:justify-end lg:max-w-[246px] lg:min-h-[106px]">
                            <p className="text-[9px] leading-[130%] z-10 max-w-full md:text-[11px] md:text-left lg:text-[16px] lg:max-w-[150px]">
                                дайджест ділової жінки Womo.ua
                            </p>
                            <span
                                className="absolute z-10 w-[73px] h-[73px] bg-[#F4F0EA] rounded-full flex items-center justify-center bottom-[35px] -right-[40px] md:-bottom-[7px] md:right-auto md:-left-[55px] lg:w-[120px] lg:h-[120px]">
                                <img src={Womo} alt="womo" className="w-[60%] relative z-10" />
                                <img src={OrgDecor} className="absolute h-full w-full object-cover -right-[2px] md:right-0  top-[3px]"/>
                            </span>
                            <span
                                className="absolute w-[60px] h-[18px] -top-[60px] right-0 md:w-[110px] md:h-[23px] md:right-[125%] md:top-[15px] 
                                    lg:w-[175px] lg:h-[53px] lg:right-[110%] lg:top-[25px]">
                                <svg viewBox="0 0 154 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L34 34H154" stroke="#E8B500" strokeWidth="2" strokeDasharray="10 10" />
                                </svg>
                            </span>
                        </a>
                    </div>

                </div>

                <h2 className="relative text-xl text-center font-bold uppercase mb-6 z-10 lg:text-3xl lg:mb-16">БІЗНЕС-ЗАХОДИ КОМПАНІЇ:</h2>

                <div className="relative flex flex-col gap-3 pb-3 md:flex-row md:justify-center md:flex-wrap md:gap-y-4 md:gap-x-6 z-10">
                    <a href="https://get.delo.ua/" target="_blank" className="relative  flex items-center gap-4 pr-2  md:basis-[calc(50%-12px)] xl:basis-[calc(33.333%-16px)]">
                        <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                        shadow-[0_4px_12px_0_rgba(0,0,0,0.25)] ">
                            <img src={Get} alt="Delo.ua" className="w-2/3" />
                        </div>
                        <p className="text-base uppercase font-semibold text-black">ГРАЙ ЯК ВЕЛИКИЙ. Навіть якщо малий</p>

                        <div className="absolute rounded-lg right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                        bg-[#C7D1DA]"></div>
                    </a>
                    <a href="https://mrktng.mmr.ua/" target="_blank" className="relative flex items-center gap-4 pr-2  md:basis-[calc(50%-12px)] xl:basis-[calc(33.333%-16px)]">
                        <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                        shadow-[0_4px_12px_0_rgba(0,0,0,0.25)]">
                            <img src={Mrktng} alt="Delo.ua" className="w-2/3" />
                        </div>
                        <p className="text-base uppercase font-semibold text-black">MRKTNG-марафон: Підкреслити головне</p>

                        <div className="absolute rounded-lg right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                        bg-[#C7D1DA]"></div>
                    </a>
                    <a href="https://prmrfn.mmr.ua/" target="_blank" className="relative flex items-center gap-4 pr-2 md:basis-[calc(50%-12px)] xl:basis-[calc(33.333%-16px)]">
                        <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                        shadow-[0_4px_12px_0_rgba(0,0,0,0.25)]">
                            <img src={Prmrfn} alt="Delo.ua" className="w-2/3" />
                        </div>
                        <p className="text-base uppercase font-semibold text-black">PR-марафон: у дзеркалі реальності</p>

                        <div className="absolute rounded-lg right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                        bg-[#C7D1DA]"></div>
                    </a>
                    <a href="https://bws.delo.ua/" target="_blank" className="relative flex items-center gap-4 pr-2 md:basis-[calc(50%-12px)] xl:basis-[calc(33.333%-16px)]">
                        <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                        shadow-[0_4px_12px_0_rgba(0,0,0,0.25)]">
                            <img src={Bws} alt="Delo.ua" className="w-2/3" />
                        </div>
                        <p className="text-base uppercase font-semibold text-black">БІЗНЕСИ СМІЛИВИХ</p>

                        <div className="absolute rounded-lg right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                        bg-[#C7D1DA]"></div>
                    </a>
                    <a href="https://she.womo.ua/" target="_blank" className="relative flex items-center gap-4 pr-2 md:basis-[calc(50%-12px)] xl:basis-[calc(33.333%-16px)]">
                        <div className="w-20 h-20 bg-white flex items-center justify-center flex-shrink-0 rounded-full lg:w-32 lg:h-32
                        shadow-[0_4px_12px_0_rgba(0,0,0,0.25)]">
                            <img src={She} alt="Delo.ua" className="w-2/3" />
                        </div>
                        <p className="text-base uppercase font-semibold text-black">SHE CONGRESS: Рішуча. Справжня. Небайдужа.</p>

                        <div className="absolute rounded-lg right-0 top-1/2 -translate-y-1/2 h-16 w-[90%] -z-10 lg:h-24
                        bg-[#C7D1DA]"></div>
                    </a>
                </div>
            </div>
        </section>
    );
};

export default EventOrganizers;